// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__FoylX","intro__inner":"intro_intro__inner__MtuaC","intro__inner-btns":"intro_intro__inner-btns__n0aem","aster":"intro_aster__4p1Bp","star":"intro_star__aXN+v"};